/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {BackLinkComponent} from './back-link/back-link.component';
import {BackTopDirective} from './back-top.directive';
import {ChipsOptionComponent} from './chips/chips-option/chips-option.component';
import {ChipsComponent} from './chips/chips.component';
import {ClearCharactersInputDirective} from './clear-charachers-input/clear-characters-input.directive';
import {ClickOutsideModule} from './click-outside/click-outside.module';
import {ContractSwitcherComponent} from './contract-switcher/contract-switcher.component';
import {DatePickerInputComponent} from './datepicker-input/datepicker-input.component';
import {DrawerComponent} from './drawer/drawer.component';
import {DropdownModule} from './dropdown/dropdown.module';
import {ExpandableBoxComponent} from './expandable-box.component';
import {GpCardComponent} from './gp-card.component';
import {GuidedTourComponent} from './guided-tour/guided-tour.component';
import {
  HorizontalTimelineNodeComponent
} from './horizontal-timeline/horizontal-timeline-node/horizontal-timeline-node.component';
import {HorizontalTimelineComponent} from './horizontal-timeline/horizontal-timeline.component';
import {TimelineViewPipe} from './horizontal-timeline/timeline-view.pipe';
import {IllustratedMessageComponent} from './illustrated-message/illustrated-message.component';
import {InfiniteScrollDirective} from './infinite-scroll.directive';
import {LoadingComponent} from './loading.component';
import {MessageComponent} from './message/message.component';
import {NumberInputComponent} from './number-input.component';
import {PlatformModule} from './platform/platform.module';
import {ResizerDirective} from './resize/resizer.directive';
import {SelectModule} from './select/select.module';
import {SidePanelComponent} from './sidepanel/side-panel.component';
import {StickBetweenDirective} from './stick-between.directive';
import {StickyDirective} from './sticky.directive';
import {TableInputComponent} from './table-input.component';
import {TableModule} from './table/table.module';
import {DropdownTreeviewModule} from './tree-multi-select/dropdown-treeview.module';
import {TreeSelectModule} from './tree-select/tree-select.module';
import {WizardStepComponent} from './wizard/wizard-step/wizard-step.component';
import {WizardComponent} from './wizard/wizard.component';

import {MomentModule} from 'ngx-moment';
import {TextMaskModule} from './legacy-text-mask';
import {DatepickerModule} from './legacy-datepicker';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {RolesDirective} from '../authentication/roles/roles.directive';
import {CustomMessages} from '../forms/messages.component';
import {GpHotTableModule} from '../hot-table/gp-hot-table.module';
import {PipesModule} from '../pipes/pipes.module';
import {CopyToClipboardComponent} from "../ui/copy-to-clipboard/copy-to-clipboard.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
    MomentModule,
    DatepickerModule.forRoot(),
    TranslateModule,
    SelectModule,
    TextMaskModule,
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    FormsModule,
    GpHotTableModule,
    DropdownTreeviewModule,
    PipesModule,
    DropdownModule,
    TreeSelectModule,
    TableModule,
    PlatformModule,
    ClickOutsideModule
  ],
  declarations: [
    DatePickerInputComponent,
    DrawerComponent,
    ExpandableBoxComponent,
    LoadingComponent,
    WizardStepComponent,
    WizardComponent,
    InfiniteScrollDirective,
    StickyDirective,
    StickBetweenDirective,
    NumberInputComponent,
    RolesDirective,
    TableInputComponent,
    CustomMessages,
    MessageComponent,
    BackTopDirective,
    ResizerDirective,
    BackLinkComponent,
    IllustratedMessageComponent,
    HorizontalTimelineComponent,
    HorizontalTimelineNodeComponent,
    TimelineViewPipe,
    ChipsComponent,
    ChipsOptionComponent,
    ClearCharactersInputDirective,
    SidePanelComponent,
    GpCardComponent,
    ContractSwitcherComponent,
    CopyToClipboardComponent,
    GuidedTourComponent
  ],
  exports: [
    DatepickerModule,
    DatePickerInputComponent,
    DrawerComponent,
    ExpandableBoxComponent,
    LoadingComponent,
    WizardStepComponent,
    WizardComponent,
    InfiniteScrollDirective,
    StickyDirective,
    StickBetweenDirective,
    SelectModule,
    TextMaskModule,
    TooltipModule,
    NumberInputComponent,
    PopoverModule,
    RolesDirective,
    TableInputComponent,
    CustomMessages,
    MessageComponent,
    BackTopDirective,
    DropdownTreeviewModule,
    ResizerDirective,
    BackLinkComponent,
    IllustratedMessageComponent,
    HorizontalTimelineComponent,
    TableModule,
    ChipsComponent,
    ChipsOptionComponent,
    ClearCharactersInputDirective,
    DropdownModule,
    TreeSelectModule,
    PlatformModule,
    ClickOutsideModule,
    SidePanelComponent,
    GpCardComponent,
    ContractSwitcherComponent,
    CopyToClipboardComponent,
    GpHotTableModule,
    GuidedTourComponent
  ],
  providers: []
})
export class UiModule {
}
